import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NgSelectConfig} from '@ng-select/ng-select';

@Injectable({
  providedIn: 'root'
})
export class TranslationManagerService {

  constructor(protected translate: TranslateService, protected ngSelectConfig: NgSelectConfig) {
  }

  setTranslationForKey(key: string, target: any) {
    this.translate.get(key).subscribe((translatedText: string) => {
      target.notFoundText = translatedText;
    });
  }

  initTranslations() {
    this.setTranslationForKey('ngSelect.notFoundText', this.ngSelectConfig);
    this.translate.onLangChange.subscribe(() => {
      this.setTranslationForKey('ngSelect.notFoundText', this.ngSelectConfig);
    });
  }

}
